import { ColumnType } from "@digitallab/grid-common-frontend-components";
import * as Yup from "yup";

const typeToYup: Record<string, (column: ColumnType) => any> = {
  input: () => Yup.string(),
  selectString: () => Yup.string(),
  selectObject: () => Yup.object(),
  list: (column) => Yup.object().shape(processValidationRule(column.columns!))
};

const processValidationRule = (columns: ColumnType[]) => {
  const shape: Record<string, any> = {};

  columns.forEach((column) => {
    if (!column.name) return;

    if (typeToYup[column.type]) {
      shape[column.name] = typeToYup[column.type](column); // Call the function here!
    }

    if (column.required) shape[column.name] = shape[column.name].required(`${column.label || column.name} is required`);
    if (column.conditionalRequired) {
      shape[column.name] = shape[column.name].when(column.conditionalRequired.dependsOnName, {
        is: column.conditionalRequired.condition,
        then: Yup.string().required(`${column.label || column.name} is required`),
        otherwise: Yup.string().notRequired()
      });
    }
    if (column.customValidation) {
      shape[column.name] = column.customValidation;
    }
  });
  return shape;
};

export const generateValidationSchema = (columns: ColumnType[]) => {
  const shape = processValidationRule(columns);

  return Yup.object().shape(shape);
};
